import {
  ChangePassFormType,
  ForgotPswResetType,
  ForgotPswSendCodeType,
  ForgotPswVerifyCodeType,
  LoginForCodeType,
  LoginType,
  RegisterFormType,
} from 'src/app/shared/types/auth.types';

export namespace AuthAction {
  export class Login {
    static readonly type = '[AuthAction] Login';
    constructor(public body: LoginForCodeType) {}
  }

  export class LoginConfirm {
    static readonly type = '[AuthAction] LoginConfirm';
    constructor(public body: LoginType) {}
  }

  export class Logout {
    static readonly type = '[AuthAction] Logout';
    constructor() {}
  }

  export class CreateAccount {
    static readonly type = '[AuthAction] CreateAccount';
    constructor(public body: RegisterFormType) {}
  }

  export class ChangePass {
    static readonly type = '[AuthAction] ChangePass';
    constructor(public body: ChangePassFormType) {}
  }

  export class ForgotPswSendCode {
    static readonly type = '[AuthAction] ForgotPswSendCode';
    constructor(public body: ForgotPswSendCodeType) {}
  }

  export class ForgotPswVerifyCode {
    static readonly type = '[AuthAction] ForgotPswVerifyCode';
    constructor(public body: ForgotPswVerifyCodeType) {}
  }

  export class ForgotPswReset {
    static readonly type = '[AuthAction] ForgotPswReset';
    constructor(public body: ForgotPswResetType) {}
  }
}
